import ModalTemplate from "../template";
import Button from "../../button";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../redux/reducers/root";
import { hideModal } from "../../../../redux/actions/modals";
import { Booking } from "../../../../redux/types";
import moment from "moment-jalaali";
import { getOfficebyId } from "../../../../redux/selectors/office-type";
import { getOfficeType } from "../../../../utils/get-office-details";
import { setBookingCanceled } from "../../../../redux/actions/bookings";
import MeetingButton from "./meeting-button";
import { ReactElement, useState } from "react";
import Dialog from "../../dialog/dialog";
import CancelDialog from "../timeslot-detail/cancel-dialog";

interface Props {}

const BookingInfo: React.FC<Props> = () => {
  const modalData = useSelector((state: State) => state.modals);

  const dispatch = useDispatch();

  const hide = () => {
    dispatch(hideModal());
  };
  const booking: Booking = modalData.data?.booking;
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

  const date = moment.unix(parseInt(booking?.timeslot.dateTime));
  const dateString = date.format("dddd jYYYY/jMM/jDD ");
  const timeString = date.format("HH:MM");

  const office = useSelector(getOfficebyId(booking?.timeslot.officeId));
  const officeType = getOfficeType(office);
  const officeAdderss = office?.address?.split("-")[0];
  const officeId = office?.id;
  const isOverDue = moment().unix() > date.unix();

  const handleCanceledBooking = async (cancelDescription: string) => {
    await dispatch(setBookingCanceled(booking.id, cancelDescription, officeId));
    setShowDeleteDialog(false);
    hide();
  };

  const RowDetail = (props: { label: string; value: string | ReactElement }) => {
    const { label, value } = props;
    return (
      <>
        <div className="text-gray-600">{label}</div>
        <div className="font-medium">{value}</div>
      </>
    );
  };

  const Payment = () => {
    const hasPayment = booking?.has_payment;
    const paid = booking?.paid;

    const text = paid ? "پرداخت شده" : "پرداخت نشده";
    if (hasPayment) {
      return (
        <>
          <div className="text-gray-600">وضعیت پرداخت</div>
          <div className={`font-medium ${paid ? "text-green-700" : "text-red-600"}`}>{text}</div>
        </>
      );
    }
    return null;
  };

  // show metting url until 2 hours after meeting start
  const show_meeting_url = moment().unix() < parseInt(booking.timeslot.dateTime) + 2 * 3600;

  return (
    <ModalTemplate
      title="جزئیات رزرو"
      leftTitle={`تاریخ درخواست: ${moment(Number(booking.created) * 1000).format("jYYYY/jMM/jDD")}`}
      icon="fa fa-calendar-alt"
    >
      <Dialog
        className="overflow-hidden rounded-3xl"
        show={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <CancelDialog
          close={() => setShowDeleteDialog(false)}
          onSubmit={async (d) => await handleCanceledBooking(d.cancelDescription)}
        />
      </Dialog>
      <div className="p-3 text-sm">
        <hr className="border-1 " />
        <div className="flex flex-col gap-4 pt-2 pb-2 text-sm font-medium text-gray-700">
          <span>{dateString}</span>
          <div className="grid grid-cols-2 gap-4">
            <div>ساعت: {timeString}</div>
            <div>شناسه رزرو: {booking?.id}</div>
          </div>
        </div>
        <hr className="border-1" />
        <div className="grid grid-cols-2 gap-4 pt-2">
          <RowDetail label="نام و نام خانوادگی" value={booking?.user.name} />

          {booking?.user.tel && (
            <RowDetail label="شماره همراه" value={<a href={`tel:${booking?.user.tel}`}>{booking?.user.tel}</a>} />
          )}
          {booking?.user.email && (
            <RowDetail label="ایمیل" value={<a href={`mailto:${booking?.user.email}`}>{booking?.user.email}</a>} />
          )}
          {booking?.user.contact_tel && (
            <RowDetail
              label="شماره اضطراری"
              value={<a href={`tel:${booking?.user.contact_tel}`}>{booking?.user.contact_tel}</a>}
            />
          )}

          <RowDetail label="نوع رزرو" value={officeType} />
          {officeAdderss && <RowDetail label="محل" value={officeAdderss} />}
          <Payment />
          <RowDetail label="خدمات انتخابی" value={booking?.practiceName} />
          {booking.hasMeeting && show_meeting_url && <MeetingButton booking={booking} />}
        </div>
        {!!booking?.description && (
          <>
            <hr className="border-2" />
            <div className="pt-3 pb-3 text-sm text-gray-500">توضیحات: {booking?.description}</div>
          </>
        )}

        <div className="flex gap-2 mt-4">
          {!(isOverDue || booking.canceled) && (
            <Button
              className="w-full p-2 !text-red-500 !border-red-500"
              type="submit"
              variant="outline"
              onClick={() => setShowDeleteDialog(true)}
            >
              لغو رزرو
            </Button>
          )}
          <Button className="w-full" onClick={hide}>
            بستن توضیحات
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
};
export default BookingInfo;
